import axios, { AxiosError } from "axios";
axios.interceptors.response.use(undefined, function (error) {
    var _a, _b;
    if (error instanceof AxiosError) {
        const req = (_a = error.response) === null || _a === void 0 ? void 0 : _a.request;
        console.error(`Request failed ${req === null || req === void 0 ? void 0 : req.responseURL} ${JSON.stringify((_b = error.response) === null || _b === void 0 ? void 0 : _b.data)}`);
    }
    throw error;
});
